import { render, staticRenderFns } from "./AExcelInsCodigos.vue?vue&type=template&id=2bb51f61"
import script from "./AExcelInsCodigos.vue?vue&type=script&lang=js"
export * from "./AExcelInsCodigos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports